import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase-config";
import { navigate } from "../router";

export function renderAdminLogin(): string {
  return `
    <div class="admin-login-page">
      <div class="admin-login-card">
        <h1>Admin Login</h1>
        <p>SideScribe Admin Portal</p>

        <form id="admin-login-form">
          <div class="admin-form-group">
            <label for="admin-email">Email</label>
            <input type="email" id="admin-email" placeholder="admin@sidescribe.ai" required />
          </div>
          <div class="admin-form-group">
            <label for="admin-password">Password</label>
            <input type="password" id="admin-password" placeholder="Password" required />
          </div>
          <div id="admin-login-error" class="admin-error" style="display:none;"></div>
          <button type="submit" class="admin-btn admin-btn-primary" id="admin-login-btn">Log In</button>
        </form>
      </div>
    </div>
  `;
}

export function mountAdminLogin(): void {
  const form = document.getElementById("admin-login-form") as HTMLFormElement;
  const errorEl = document.getElementById("admin-login-error")!;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    errorEl.style.display = "none";

    const email = (document.getElementById("admin-email") as HTMLInputElement).value.trim();
    const password = (document.getElementById("admin-password") as HTMLInputElement).value;
    const btn = document.getElementById("admin-login-btn") as HTMLButtonElement;

    btn.disabled = true;
    btn.textContent = "Logging in...";

    try {
      const credential = await signInWithEmailAndPassword(auth, email, password);

      // Check if user is admin
      const userDoc = await getDoc(doc(db, "users", credential.user.uid));
      if (!userDoc.exists() || !userDoc.data()?.isAdmin) {
        await auth.signOut();
        errorEl.textContent = "Access denied. Admin privileges required.";
        errorEl.style.display = "block";
        return;
      }

      navigate("#/users");
    } catch (err: any) {
      errorEl.textContent = "Invalid email or password.";
      errorEl.style.display = "block";
    } finally {
      btn.disabled = false;
      btn.textContent = "Log In";
    }
  });
}
